// @flow

import React from "react"

export default class OpenAsModalImage extends React.Component {
  state = {
    open: false,
  }

  render() {
    return (
      <div>
        <img
          onClick={() => this.setState({ open: true })}
          alt={this.props.alt || ""}
          src={this.props.src}
          className="modal-preview"
        />

        {this.state.open && (
          <div
            className="modal-bg"
            onClick={() => this.setState({ open: false })}
          >
            <img
              alt={this.props.alt || ""}
              src={this.props.src}
              className="modal-img"
            />
          </div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/OpenAsModalImage.js